module.exports = __webpack_public_path__ + "static/media/clock.09c6119c.svg";